import { Injectable, signal } from '@angular/core';
import { Department } from '@interfaces/data/department';

@Injectable({
  providedIn: 'root',
})
export class DepartmentService {
  departments = signal<Department[]>([]);

  setDepartments(data: Department[]) {
    this.departments.set(data);
  }
}
